import clsx, { type ClassValue } from "clsx";

/** Tailwind class merge helper. */
export function cn(...args: ClassValue[]): string {
  return clsx(...args);
}
